<template>
  <DashboardHeader title="Manage Data">
    <CrudTables :tables="tables"></CrudTables>
  </DashboardHeader>
</template>

<script>
import DashboardHeader from "@/components/DashboardHeader.vue";
import CrudTables from "@/components/myLibrary/CrudTables.vue";

export default {
  components: {
    DashboardHeader,
    CrudTables,
  },

  data() {
    return {
      tables: [
        { text: "Application Dates", value: "application_dates" },
        { text: "Blocked Reports", value: "blocked_reports" },
        {
          text: "Classes",
          value: "classes",
        },
        {
          text: "Staff Roles",
          value: "staff_roles",
        },
        {
          text: "Staff Earnings",
          value: "earnings",
        },
        {
          text: "Staff Deductions",
          value: "deductions",
        },
        {
          text: "Comments",
          value: "comments",
        },
        {
          text: "Contacts",
          value: "contact_numbers",
        },
        {
          text: "Enquiries",
          value: "contact_us",
        },
        {
          text: "Fees",
          value: "fees_all_times",
        },
        {
          text: "Subjects",
          value: "subjects",
        },
        {
          text: "Terms",
          value: "terms",
        },
      ],
    };
  },
};
</script>
